/**
 * @file 获取学习项目-积分列表
 * @author liudy
 * @see http://api.umucdn.cn/project/151/interface/api/2045
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IGetRankListInput {
    program_id: string;
}

export interface IGetRankListOutput extends IUserBaseInfo {
    total_point_rank: number;
}

// tslint:disable-next-line:max-line-length
export const getRankList = (data: IGetRankListInput): Promise<IListResponse<IGetRankListOutput>> => {
    return fetchData(Api.GET_PROGRAM_RANK_LIST, data).then((res: IListResponse<IGetRankListOutput>) => {
        return res;
    });
};

export const getRankListSync = fetchDataSync(getRankList);
